<template>
  <TemplateView>
    <div class="container">
      <TemplatePageGrid
        :items="SettingWorkDocsWorkAreaPage ? workClientProjectGrid : workDocsWorkAreaGrid_project"
        :page-data="pageData"
        :loading="loadingAnimation"
        sort-az="last_name"
      >
        <template v-slot:buttons>
          <WorkDocsWorkAreaModal
            v-if="
              !SettingWorkDocsWorkAreaPage &&
              $userCheckAccess({
                abilities: 'edit_document_types',
              })
            "
            :create="true"
          />
        </template>
        <WorkDocsWorkAreaTable
          :items="
            SettingWorkDocsWorkAreaPage ? workClientProjectGrid : workDocsWorkAreaGrid_project
          "
        />
      </TemplatePageGrid>
    </div>
  </TemplateView>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import TemplateView from 'components/templates/TemplateView'
import TemplatePageGrid from 'components/templates/TemplatePageGrid'
import WorkDocsWorkAreaTable from 'components/setting/workDocsWorkArea/WorkDocsWorkAreaTable'
import WorkDocsWorkAreaModal from 'components/setting/workDocsWorkArea/WorkDocsWorkAreaModal'

export default {
  name: 'WorkDocsWorkArea',
  components: {
    TemplateView,
    TemplatePageGrid,
    WorkDocsWorkAreaTable,
    WorkDocsWorkAreaModal,
  },
  data() {
    return {
      projectList: null,
    }
  },
  created() {
    this.downloadPageData()
  },
  watch: {
    '$route.query'() {
      this.downloadPageData()
    },
    SettingWorkDocsWorkAreaPage() {
      this.downloadPageData()
    },
  },
  computed: {
    ...mapGetters('workDocsWorkArea', ['workDocsWorkAreaGrid_project']),
    ...mapGetters('workClientProject', [
      'workClientProjectGrid',
      'workClientProjectShow',
      'pageData',
    ]),
    ...mapGetters(['loadingAnimation']),
    pageDataProject() {
      return this.$store.getters['workDocsWorkArea/pageData']
    },
    SettingWorkDocsWorkAreaPage() {
      return this.$route.name === 'SettingWorkDocsWorkArea'
    },
  },
  methods: {
    ...mapActions('workDocsWorkArea', ['onWorkDocsWorkAreaGrid_project']),
    ...mapActions('workClientProject', ['onWorkClientProjectGrid', 'onWorkClientProjectShow']),
    downloadPageData() {
      let data = {
        limit: this.$route.query.limit,
        page: this.$route.query.page,
      }
      if (this.$route.query.sort_param && this.$route.query.sort_value) {
        data.sort = {
          param: this.$route.query.sort_param,
          value: this.$route.query.sort_value,
        }
      }
      if (this.$route.query.search) {
        data.search = this.$route.query.search
      }
      if (this.SettingWorkDocsWorkAreaPage) {
        this.onWorkClientProjectGrid(data)
      } else {
        data.project_id = this.$route.params.id
        this.onWorkDocsWorkAreaGrid_project(data)
        this.onWorkClientProjectShow(this.$route.params.id)
      }
    },
  },
}
</script>
